"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPPOSITE_DIRECTIONS = exports.PLACEMENTS = exports.PLACEMENTS_SIDES = exports.PLACEMENTS_VERT = exports.PLACEMENTS_HORIZ = void 0;
var PLACEMENTS_HORIZ = ['left', 'right'];
exports.PLACEMENTS_HORIZ = PLACEMENTS_HORIZ;
var PLACEMENTS_VERT = ['top', 'bottom'];
exports.PLACEMENTS_VERT = PLACEMENTS_VERT;
var PLACEMENTS_SIDES = PLACEMENTS_HORIZ.concat(PLACEMENTS_VERT);
exports.PLACEMENTS_SIDES = PLACEMENTS_SIDES;
var PLACEMENTS = PLACEMENTS_SIDES.concat(['left top', 'left bottom', 'right top', 'right bottom', 'top left', 'top right', 'bottom left', 'bottom right']);
exports.PLACEMENTS = PLACEMENTS;
var OPPOSITE_DIRECTIONS = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
  middle: 'middle',
  center: 'center'
};
exports.OPPOSITE_DIRECTIONS = OPPOSITE_DIRECTIONS;